import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","CookiePolicyDataId"] */ "/codebuild/output/src2919109647/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
